import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-banner',
	templateUrl:'./WaPageBannerProPage.html',
	styles: [],
	styleUrls:['./WaPageBannerProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageBannerProPage
{
	mdContent_380 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageBanner;
\`\`\``;
	mdContent_381 = `\`\`\`java
new WaPageBanner<>()
\`\`\``;
}
